export const URL = 'v1/homePage/homeShopListWithOptions';
export const NUCLEAR_URL = 'v1/status/refresh';

export async function landingPageRequest(): Promise<{
  code: number;
  data: any;
  msg: string;
}> {
  const url = URL;
  const param = {};
  const networkModule = Mach.requireModule('Network');
  const params = {
    dataType: 'json',
    url,
    method: 'POST',
    params: null,
    data: {
      ...param,
    },
  };
  const indicatorModule = Mach.requireModule('ActivityIndicator');
  indicatorModule.showLoading();
  return new Promise<any>((resolve, reject) => {
    networkModule.request(params, (result: any) => {
      indicatorModule.hideLoading();
      if (result.error) {
        reject('landingPageRequest error: c_area_preheat ~~~');
      } else {
        const msg = result.data?.msg || result.data?.message;
        if (result.data && result.data.code == 0 && (result.data.data || result.data?.success)) {
          resolve({
            data: result.data?.data,
            code: result.data?.code,
            msg,
          });
        } else {
          resolve({
            data: result.data?.data,
            code: result.data?.code,
            msg,
          });
        }
      }
    });
  });
}

export async function nuclearRefreshRequest(): Promise<{
  code: number;
  data: any;
  msg: string;
}> {
  const url = NUCLEAR_URL;
  const param = {
    mainBundleVersion: Mach.env.bundleVersion,
    location: getLatLng()
  };
  const networkModule = Mach.requireModule('Network');
  const params = {
    dataType: 'json',
    url,
    method: 'POST',
    params: null,
    data: {
      ...param,
    },
  };
  return new Promise<any>((resolve, reject) => {
    networkModule.request(params, (result: any) => {
      if (result.error) {
        reject(result);
      } else {
        const msg = result.data?.msg || result.data?.message;
        if (result?.data?.code === 0 && (result?.data?.data || result?.data?.success)) {
          resolve({
            data: result.data?.data,
            code: result.data?.code,
            msg,
          });
        } else {
          reject(result);
        }
      }
    });
  });
}

// 获取经纬度
export function getLatLng() {
  const SLLocation = Mach.requireModule('SLLocation');
  const location = SLLocation?.getLocation() || {};
  return {
    latitude: location?.latitude,
    longitude: location?.longitude,
    actualLatitude: location?.actualLatitude,
    actualLongitude: location?.actualLongitude,
  };
}
